var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documents_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87 2.887a1.999 1.999 0 0 0-.246.56l-.113.422a1.495 1.495 0 0 0-.585.14L2.488 6.545a1.5 1.5 0 0 0-.725 1.993l3.944 8.459a1.5 1.5 0 0 0 1.994.725l3.8-1.771 1.502.402-4.88 2.276a2.5 2.5 0 0 1-3.322-1.21L.857 8.961a2.5 2.5 0 0 1 1.209-3.323l5.438-2.535a2.488 2.488 0 0 1 1.366-.216ZM7.481 7.71l-.337 1.261-1.686.786a.5.5 0 0 1-.423-.906l2.446-1.14Z",
    fill: "#818C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 2.887a1.999 1.999 0 0 0-.246.56l-.113.422a1.495 1.495 0 0 0-.585.14L2.488 6.545a1.5 1.5 0 0 0-.725 1.993l3.944 8.459a1.5 1.5 0 0 0 1.994.725l3.8-1.771 1.502.402-4.88 2.276a2.5 2.5 0 0 1-3.322-1.21L.857 8.961a2.5 2.5 0 0 1 1.209-3.323l5.438-2.535a2.488 2.488 0 0 1 1.366-.216ZM7.481 7.71l-.337 1.261-1.686.786a.5.5 0 0 1-.423-.906l2.446-1.14Z",
    fill: "#747F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14 3.317a2.5 2.5 0 0 1 3.062-1.767l5.795 1.553a2.5 2.5 0 0 1 1.768 3.061L16.35 15.18a2.5 2.5 0 0 1-3.062 1.768l-5.796-1.553a2.5 2.5 0 0 1-1.768-3.062L8.14 3.317Zm2.803-.801a1.5 1.5 0 0 0-1.837 1.06L6.69 12.592a1.5 1.5 0 0 0 1.061 1.837l5.796 1.553a1.5 1.5 0 0 0 1.837-1.061l2.415-9.015a1.5 1.5 0 0 0-1.06-1.837l-5.796-1.553Zm-.144 4.59a.5.5 0 0 1 .613-.353l3.22.863a.5.5 0 0 1-.26.965l-3.22-.862a.5.5 0 0 1-.353-.613Zm-.035 2.062a.5.5 0 1 0-.258.966l3.22.862a.5.5 0 1 0 .258-.966l-3.22-.862Z",
    fill: "#818C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14 3.317a2.5 2.5 0 0 1 3.062-1.767l5.795 1.553a2.5 2.5 0 0 1 1.768 3.061L16.35 15.18a2.5 2.5 0 0 1-3.062 1.768l-5.796-1.553a2.5 2.5 0 0 1-1.768-3.062L8.14 3.317Zm2.803-.801a1.5 1.5 0 0 0-1.837 1.06L6.69 12.592a1.5 1.5 0 0 0 1.061 1.837l5.796 1.553a1.5 1.5 0 0 0 1.837-1.061l2.415-9.015a1.5 1.5 0 0 0-1.06-1.837l-5.796-1.553Zm-.144 4.59a.5.5 0 0 1 .613-.353l3.22.863a.5.5 0 0 1-.26.965l-3.22-.862a.5.5 0 0 1-.353-.613Zm-.035 2.062a.5.5 0 1 0-.258.966l3.22.862a.5.5 0 1 0 .258-.966l-3.22-.862Z",
    fill: "#747F88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documents_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0Z",
    fill: "#fff"
  })))));
};

export default SvgDocuments;